const register2 = email => `
                        <div class="verify-email">
                            <div>
                                Once you verify your email address, you and your team will be able to use Heelix
                                on our free plan.
                            </div>
                            <div>
                                You can keep using Heelix Connect or upgrade to Heelix Perform & Engage to
                                discover our premium features.
                            </div>
                            <div class="verify-didnt-receive">
                                Didn't receive an email? <a id="resend-verify-step">Click here</a>.
                            </div>
                        </div>
`;

export default register2;